import { render, staticRenderFns } from "./Fa1Approve.vue?vue&type=template&id=61181309"
import script from "./Fa1Approve.vue?vue&type=script&lang=js"
export * from "./Fa1Approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports